// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1Mom7","select":"Header_select__25vom","clinic":"Header_clinic__3vtMr"};